import { render, staticRenderFns } from "./myCases.vue?vue&type=template&id=852d0e96&scoped=true"
import script from "./myCases.vue?vue&type=script&lang=js"
export * from "./myCases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852d0e96",
  null
  
)

export default component.exports